export default __webpack_public_path__ + "assets/img/pgnb-style2-arrow.svg";